import { render } from "./DebugFragenblock.vue?vue&type=template&id=6725e46e&ts=true"
import script from "./DebugFragenblock.vue?vue&type=script&lang=ts"
export * from "./DebugFragenblock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__